import { GoogleAuthProvider, getAuth } from 'firebase/auth';

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { config } from './config';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: config.FIREBASE_API_KEY,
  authDomain: config.FIREBASE_AUTH_DOMAIN,
  projectId: config.FIREBASE_PROJECT_ID,
  storageBucket: config.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID,
  appId: config.FIREBASE_APP_ID,
  measurementId: config.FIREBASE_MEASUREMENT_ID,
};

// Debug output
console.log('Initializing Firebase with config:', {
  apiKey: firebaseConfig.apiKey ? 'PRESENT' : 'MISSING',
  authDomain: firebaseConfig.authDomain ? 'PRESENT' : 'MISSING',
  projectId: firebaseConfig.projectId ? 'PRESENT' : 'MISSING',
  storageBucket: firebaseConfig.storageBucket ? 'PRESENT' : 'MISSING',
  messagingSenderId: firebaseConfig.messagingSenderId ? 'PRESENT' : 'MISSING',
  appId: firebaseConfig.appId ? 'PRESENT' : 'MISSING',
  measurementId: firebaseConfig.measurementId ? 'PRESENT' : 'MISSING',
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
